import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';

import { FeatureCtaContainer } from 'containers/common/app/feature-cta-container';
import { FaqContainer } from 'containers/common/components/faq/faq-container';
import { TravelModeBlockOneContainer } from 'containers/features/travel-mode/travel-mode-block-one-container';
import { TravelModeBlockThreeContainer } from 'containers/features/travel-mode/travel-mode-block-three-container';
import { TravelModeBlockTwoContainer } from 'containers/features/travel-mode/travel-mode-block-two-container';
import { TravelModeHeroBlockContainer } from 'containers/features/travel-mode/travel-mode-hero-block-container';
import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

const faqContent = () => [
  {
    question: features.travelMode.lxTravelModeFaqQuestionOneTitle,
    answer: features.travelMode.lxTravelModeFaqQuestionOneAnswer,
  },
  {
    question: features.travelMode.lxTravelModeFaqQuestionTwoTitle,
    answer: features.travelMode.lxTravelModeFaqQuestionTwoAnswer,
  },
  {
    question: features.travelMode.lxTravelModeFaqQuestionThreeTitle,
    answer: features.travelMode.lxTravelModeFaqQuestionThreeAnswer,
  },
];

export const TravelModeContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <TravelModeHeroBlockContainer />
        <TravelModeBlockOneContainer />
        <TravelModeBlockTwoContainer />
        <TravelModeBlockThreeContainer />
        <FaqContainer title={features.travelMode.lxFeaturesFaqTitle} content={faqContent()} />
        <FeatureCtaContainer title={features.travelMode.lxTravelModeCta} />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
